import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { tap } from 'rxjs/operators';

import produce from 'immer';

import {
  ENTITY_CONNECTIONS_CHANGED
} from 'app/_state/entity/view-entity/entity-connections/entity-connection.actions';

import { UpdateEntityConnectionGQL } from 'generated/graphql';

@Injectable({ providedIn: 'root' })
export class UpdateEntityConnectionStatusService {

  constructor(
    private _updateEntityConnectionGQL: UpdateEntityConnectionGQL,
    private _store: Store
  ) {
  }

  /**
   * Deletes an entity connection and performs query / cache
   * updates
   */
  updateEntityConnectionStatus(
    input: {
      campaignId: string;
      entityConnectionId: string;
      status: boolean;
    }
  ) {

    return this._updateEntityConnectionGQL.mutate({
      input
    }).pipe(
      tap((res) => {
        this._store.dispatch(
          ENTITY_CONNECTIONS_CHANGED({
            payload: {
              entityConnection: res.data.updateEntityConnection.entityConnection
            }
          })
        );

      })
    );
  }
}
